export default {
  REGISTER: 'register',
  VERIFY: 'verify',
};
